import { useInfiniteQuery } from "@tanstack/react-query";
import { usageMetricsService } from "@/features/usage-logs/api/usage-metrics-service";
import type { UsageMetricsFilter } from "@/features/usage-logs/types";

const PAGE_SIZE = 30;

interface ResourceUsageParams {
  sourceEntityType: string;
  sourceEntityId: string;
  filter?: Omit<UsageMetricsFilter, "sourceEntityType" | "sourceEntityId">;
  enabled?: boolean;
  limit?: number;
}

export function useResourceUsageQuery({
  sourceEntityType,
  sourceEntityId,
  filter = {},
  enabled = true,
  limit = PAGE_SIZE,
}: ResourceUsageParams) {
  return useInfiniteQuery({
    queryKey: ["resource-activity", "usage", sourceEntityType, sourceEntityId, filter, limit],
    queryFn: ({ pageParam = null }) =>
      usageMetricsService.getResourceLogs(
        { ...filter, sourceEntityType, sourceEntityId },
        pageParam as string | null,
        limit,
      ),
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: null as string | null,
    enabled: enabled && Boolean(sourceEntityType && sourceEntityId),
    staleTime: 0,
    refetchOnMount: "always",
  });
}
